module.exports = __webpack_public_path__ + "img/tabbar1-1.9c10db2a.svg";